import React, { Component, ErrorInfo, ReactNode } from "react";

interface IProps {
  children: ReactNode;
  error?: Error;
}

interface IState {
  error: Error | null;
}

export class ErrorBoundary extends Component<IProps, IState> {
  public static getDerivedStateFromError(error: Error) {
    return { error };
  }
  constructor(props: IProps) {
    super(props);
    this.state = { error: null };
  }
  public componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
  }
  public render() {
    let error: Error | null = null;
    if (this.props.error !== undefined) {
      error = this.props.error;
    } else if (this.state.error !== null) {
      error = this.state.error;
    }
    if (error === null) {
      return this.props.children;
    }
    return (
      <div className="p-4">
        <div className="alert alert-danger">{error.message}</div>
      </div>
    );
  }
}
